import createReactComponent from '../createReactComponent';
export default createReactComponent('reorder', 'IconReorder', [
  [
    'path',
    {
      d: 'M3 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z',
      key: 'svg-0',
    },
  ],
  [
    'path',
    {
      d: 'M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z',
      key: 'svg-1',
    },
  ],
  [
    'path',
    {
      d: 'M17 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z',
      key: 'svg-2',
    },
  ],
  ['path', { d: 'M5 11v-3a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v3', key: 'svg-3' }],
  ['path', { d: 'M16.5 8.5l2.5 2.5l2.5 -2.5', key: 'svg-4' }],
]);
